// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AiCredits_PegOverridesQueryInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Query-string input for GET /ai/credits/peg-overrides.
 *
 * Optional:
 *   franquia_id (int|null) — absent/0 lists every override currently IN FORCE
 *     across all franchises (the staff roster); present lists that franchise's
 *     FULL history, closed windows included, because a closed window is the
 *     evidence for the burns priced under it.
 */
import { registerContract } from './validate'

export interface AiCredits_PegOverridesQueryInput {
franquia_id?: number
}

registerContract('AiCredits_PegOverridesQueryInput', {
  franquia_id: { type: 'number',  required: false },
})
